import { PageLocatorMap } from '../types/PageLocatorMap';

export const loanDocumentUploadPage = {
  alert: {
    error: 'loan-document-upload-page.form.alert.error',
  },
  footer: {
    root: 'loan-document-upload-page.footer.root',
  },
  form: {
    cancelButton: 'loan-document-upload-page.form.cancel-button',
    exampleLink: 'loan-document-upload-page.form.example-link',
    exampleRoot: 'loan-document-upload-page.form.example-root',
    h1: 'loan-document-upload-page.form.h1',
    h2: 'loan-document-upload-page.form.h2',
    root: 'loan-document-upload-page.form.root',
    submitButton: 'loan-document-upload-page.form.submit-button',
  },
} as const satisfies PageLocatorMap;
